module.exports = __webpack_public_path__ + "img/GERA_ Home_Logo.png";